import { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { SommelierWidget } from '../components/vini/SommelierWidget';

const API = process.env.REACT_APP_BACKEND_URL;

const TESTI = {
  it: { carta: 'Carta dei Vini', caricamento: 'Preparazione della carta...', vuoto: 'Nessun vino disponibile', annata: 'Annata', abbinamenti: 'Abbinamenti', traduzione: 'Traduzione in corso', sommTitolo: 'Sommelier', sommDomanda: 'Dimmi cosa stai mangiando e ti consiglio il vino perfetto.', sommPlaceholder: 'Es. tagliata di manzo, spaghetti alle vongole...', sommBtn: 'Consigliami un vino', sommPensando: 'Il sommelier sta scegliendo...', sommErrore: 'Servizio momentaneamente non disponibile, riprova.', sommAltro: 'Chiedi un altro consiglio', sommPrestige: 'Selezione di prestigio', sommValue: 'Ottimo rapporto qualità-prezzo', erroreCarta: 'Non riusciamo a caricare la carta in questo momento', riprova: 'Riprova', cercaVino: 'Cerca vino o cantina...', tuttiTipi: 'Tutti i tipi', tutteRegioni: 'Tutte le regioni', gradTutte: 'Gradazione', azzera: 'Azzera filtri', nessunRisultato: 'Nessun vino trovato con questi filtri' },
  en: { carta: 'Wine List', caricamento: 'Preparing the wine list...', vuoto: 'No wines available', annata: 'Vintage', abbinamenti: 'Pairings', traduzione: 'Translating', sommTitolo: 'Sommelier', sommDomanda: 'Tell me what you are eating and I will suggest the perfect wine.', sommPlaceholder: 'E.g. beef steak, spaghetti with clams...', sommBtn: 'Recommend a wine', sommPensando: 'The sommelier is choosing...', sommErrore: 'Service temporarily unavailable, please retry.', sommAltro: 'Ask for another suggestion', sommPrestige: 'Prestige selection', sommValue: 'Great value picks', erroreCarta: 'We are unable to load the wine list right now', riprova: 'Retry', cercaVino: 'Search wine or winery...', tuttiTipi: 'All types', tutteRegioni: 'All regions', gradTutte: 'Alcohol', azzera: 'Clear filters', nessunRisultato: 'No wines match these filters' },
  fr: { carta: 'Carte des Vins', caricamento: 'Préparation de la carte...', vuoto: 'Aucun vin disponible', annata: 'Millésime', abbinamenti: 'Accords', traduzione: 'Traduction en cours', sommTitolo: 'Sommelier', sommDomanda: 'Dites-moi ce que vous mangez et je vous conseillerai le vin parfait.', sommPlaceholder: 'Ex. entrecôte, spaghetti aux palourdes...', sommBtn: 'Conseillez-moi un vin', sommPensando: 'Le sommelier choisit...', sommErrore: 'Service momentanément indisponible, réessayez.', sommAltro: 'Demander un autre conseil', sommPrestige: 'Sélection de prestige', sommValue: 'Excellent rapport qualité-prix', erroreCarta: 'Impossible de charger la carte pour le moment', riprova: 'Réessayer', cercaVino: 'Chercher un vin ou un domaine...', tuttiTipi: 'Tous les types', tutteRegioni: 'Toutes les régions', gradTutte: 'Degré', azzera: 'Effacer les filtres', nessunRisultato: 'Aucun vin ne correspond à ces filtres' },
  es: { carta: 'Carta de Vinos', caricamento: 'Preparando la carta...', vuoto: 'No hay vinos disponibles', annata: 'Añada', abbinamenti: 'Maridajes', traduzione: 'Traduciendo', sommTitolo: 'Sommelier', sommDomanda: 'Dime qué estás comiendo y te aconsejo el vino perfecto.', sommPlaceholder: 'Ej. chuletón, espaguetis con almejas...', sommBtn: 'Recomiéndame un vino', sommPensando: 'El sommelier está eligiendo...', sommErrore: 'Servicio no disponible temporalmente, reintenta.', sommAltro: 'Pedir otro consejo', sommPrestige: 'Selección de prestigio', sommValue: 'Excelente relación calidad-precio', erroreCarta: 'No podemos cargar la carta en este momento', riprova: 'Reintentar', cercaVino: 'Buscar vino o bodega...', tuttiTipi: 'Todos los tipos', tutteRegioni: 'Todas las regiones', gradTutte: 'Graduación', azzera: 'Borrar filtros', nessunRisultato: 'Ningún vino coincide con estos filtros' },
  de: { carta: 'Weinkarte', caricamento: 'Weinkarte wird vorbereitet...', vuoto: 'Keine Weine verfügbar', annata: 'Jahrgang', abbinamenti: 'Empfehlungen', traduzione: 'Übersetzung läuft', sommTitolo: 'Sommelier', sommDomanda: 'Sagen Sie mir, was Sie essen, und ich empfehle den perfekten Wein.', sommPlaceholder: 'Z.B. Rindersteak, Spaghetti mit Venusmuscheln...', sommBtn: 'Wein empfehlen', sommPensando: 'Der Sommelier wählt aus...', sommErrore: 'Dienst vorübergehend nicht verfügbar, bitte erneut versuchen.', sommAltro: 'Weitere Empfehlung anfragen', sommPrestige: 'Prestige-Auswahl', sommValue: 'Preis-Leistungs-Tipps', erroreCarta: 'Die Weinkarte kann derzeit nicht geladen werden', riprova: 'Erneut versuchen', cercaVino: 'Wein oder Weingut suchen...', tuttiTipi: 'Alle Typen', tutteRegioni: 'Alle Regionen', gradTutte: 'Alkoholgehalt', azzera: 'Filter zurücksetzen', nessunRisultato: 'Keine Weine entsprechen diesen Filtern' },
  zh: { carta: '葡萄酒单', caricamento: '正在准备酒单...', vuoto: '暂无葡萄酒', abbinamenti: '搭配建议', annata: '年份', traduzione: '翻译中', sommTitolo: '侍酒师', sommDomanda: '告诉我您在吃什么，我为您推荐最合适的葡萄酒。', sommPlaceholder: '例如：牛排、蛤蜊意面...', sommBtn: '为我推荐葡萄酒', sommPensando: '侍酒师正在挑选...', sommErrore: '服务暂时不可用，请重试。', sommAltro: '再来一个建议', sommPrestige: '尊享甄选', sommValue: '高性价比之选', erroreCarta: '暂时无法加载酒单', riprova: '重试', cercaVino: '搜索葡萄酒或酒庄...', tuttiTipi: '所有类型', tutteRegioni: '所有产区', gradTutte: '酒精度', azzera: '清除筛选', nessunRisultato: '没有符合筛选条件的葡萄酒' }
};

const TIPI_LABEL = {
  it: { champagne: 'Champagne', bollicine: 'Bollicine', prosecco: 'Prosecco', bianco: 'Vini Bianchi', rosso: 'Vini Rossi', rosato: 'Vini Rosati', dolce: 'Vini Dolci', altro: 'Altri Vini' },
  en: { champagne: 'Champagne', bollicine: 'Sparkling Wines', prosecco: 'Prosecco', bianco: 'White Wines', rosso: 'Red Wines', rosato: 'Rosé Wines', dolce: 'Sweet Wines', altro: 'Other Wines' },
  fr: { champagne: 'Champagne', bollicine: 'Vins Effervescents', prosecco: 'Prosecco', bianco: 'Vins Blancs', rosso: 'Vins Rouges', rosato: 'Vins Rosés', dolce: 'Vins Doux', altro: 'Autres Vins' },
  es: { champagne: 'Champagne', bollicine: 'Espumosos', prosecco: 'Prosecco', bianco: 'Vinos Blancos', rosso: 'Vinos Tintos', rosato: 'Rosados', dolce: 'Vinos Dulces', altro: 'Otros Vinos' },
  de: { champagne: 'Champagner', bollicine: 'Schaumweine', prosecco: 'Prosecco', bianco: 'Weißweine', rosso: 'Rotweine', rosato: 'Roséweine', dolce: 'Süßweine', altro: 'Weitere Weine' },
  zh: { champagne: '香槟', bollicine: '起泡酒', prosecco: '普罗塞克', bianco: '白葡萄酒', rosso: '红葡萄酒', rosato: '桃红葡萄酒', dolce: '甜酒', altro: '其他葡萄酒' }
};

const ORDINE_TIPI = ['champagne', 'bollicine', 'prosecco', 'bianco', 'rosato', 'rosso', 'dolce', 'altro'];

const TEMI = {
  avorio: { bg: '#faf6ef', testo: '#1e1812', accento: '#8b1a2f', secondario: '#524536', card: '#ffffff', bordo: '#dfd5c6' },
  scuro: { bg: '#151210', testo: '#f5efe6', accento: '#d4a860', secondario: '#c2b4a3', card: '#211c18', bordo: '#423830' },
  bordeaux: { bg: '#2b1218', testo: '#f7ede2', accento: '#e2b875', secondario: '#d4b8aa', card: '#3a1a22', bordo: '#5c333e' }
};

// Dimensione testo scelta dal cliente (A– A A+), ricordata sul telefono
const SCALE = [0.9, 1, 1.15, 1.3, 1.45];
const SCALA_KEY = 'carta_vini_font_scale';

const BottigliaVuota = ({ colore }) => (
  <svg width="30" height="96" viewBox="0 0 24 72" fill="none" stroke={colore} strokeWidth="1.2" opacity="0.4" aria-hidden="true" data-testid="carta-bottiglia-placeholder">
    <path d="M9.5 2h5v11c0 2 3.5 4 3.5 9v46a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V22c0-5 3.5-7 3.5-9V2z" />
    <line x1="6" y1="34" x2="18" y2="34" /><line x1="6" y1="48" x2="18" y2="48" />
  </svg>
);

const ControlloTesto = ({ scala, setScala, tema }) => {
  const i = SCALE.indexOf(scala);
  const btn = (label, onClick, disabled, testid, size) => (
    <button onClick={onClick} disabled={disabled} data-testid={testid} aria-label={testid}
      style={{ minWidth: 38, height: 36, border: 'none', background: 'transparent', color: disabled ? tema.bordo : tema.testo,
        fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 700, fontSize: size, cursor: disabled ? 'default' : 'pointer', transition: 'color .2s' }}>
      {label}
    </button>
  );
  return (
    <div data-testid="carta-controllo-testo" style={{ position: 'fixed', left: 12, bottom: 22, zIndex: 40, display: 'flex', alignItems: 'center',
      background: `${tema.card}d9`, backdropFilter: 'blur(14px)', WebkitBackdropFilter: 'blur(14px)', border: `1px solid ${tema.bordo}`,
      borderRadius: 999, boxShadow: '0 6px 20px rgba(0,0,0,0.16)', padding: '0 2px' }}>
      {btn('A–', () => setScala(SCALE[Math.max(0, i - 1)]), i <= 0, 'font-scale-down', 15)}
      <span style={{ width: 1, height: 20, background: tema.bordo }} />
      {btn('A', () => setScala(1), scala === 1, 'font-scale-reset', 18)}
      <span style={{ width: 1, height: 20, background: tema.bordo }} />
      {btn('A+', () => setScala(SCALE[Math.min(SCALE.length - 1, i + 1)]), i >= SCALE.length - 1, 'font-scale-up', 21)}
    </div>
  );
};

// Tipografia professionale: titoli e nomi vino in Cormorant Garamond, dettagli in Jost
const FONT_TITOLO = "'Cormorant Garamond', Georgia, serif";
const FONT_CORPO = "'Jost', 'Helvetica Neue', Arial, sans-serif";

export default function PublicCartaViniPage({ tenantId }) {
  const [dati, setDati] = useState(null);
  const [lang, setLang] = useState(localStorage.getItem('carta_vini_lang') || 'it');
  const [loading, setLoading] = useState(true);
  const [errore, setErrore] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const [imgAperta, setImgAperta] = useState(null);
  const [filtri, setFiltri] = useState({ q: '', tipo: '', regione: '', grad: '' });
  const [scala, setScalaState] = useState(() => {
    const v = parseFloat(localStorage.getItem(SCALA_KEY));
    return SCALE.includes(v) ? v : 1;
  });
  const setScala = (v) => { localStorage.setItem(SCALA_KEY, String(v)); setScalaState(v); };
  const fs = (n) => `${Math.round(n * scala * 10) / 10}px`;

  useEffect(() => {
    let attivo = true;
    setLoading(true);
    setErrore(false);
    const carica = () => axios.get(`${API}/api/carta-vini/pubblica/${tenantId}?lang=${lang}`, { timeout: 55000 });
    // Retry automatico: il refresh non deve mai mostrare "nessun vino" per un errore transitorio
    const caricaConRetry = async () => {
      let ultimoErrore = null;
      for (let i = 0; i < 3; i++) {
        try {
          const r = await carica();
          if ((r.data?.vini?.length || 0) > 0 || i === 2) return r;
        } catch (e) {
          ultimoErrore = e;
          if (i === 2) throw e;
        }
        await new Promise(res => setTimeout(res, 1200 * (i + 1)));
        if (!attivo) throw ultimoErrore || new Error('annullato');
      }
    };
    caricaConRetry()
      .then(async r => {
        if (!attivo) return;
        setDati(r.data);
        // Se le traduzioni sono in generazione, ricarica finché non sono pronte
        let tentativi = 0;
        while (r.data.traduzioni_in_corso && tentativi < 40 && attivo) {
          await new Promise(res => setTimeout(res, 4000));
          try {
            r = await carica();
            if (attivo) setDati(r.data);
          } catch (e) { break; }
          tentativi++;
        }
      })
      .catch(() => { if (attivo) setErrore(true); })
      .finally(() => { if (attivo) setLoading(false); });
    return () => { attivo = false; };
  }, [tenantId, lang, reloadKey]);

  const t = TESTI[lang] || TESTI.it;
  const tipiLabel = TIPI_LABEL[lang] || TIPI_LABEL.it;
  const tema = TEMI[dati?.settings?.tema] || TEMI.avorio;
  const settings = dati?.settings || {};

  const opzioniFiltri = useMemo(() => {
    const vini = dati?.vini || [];
    const tipi = ORDINE_TIPI.filter(tp => vini.some(v => (ORDINE_TIPI.includes(v.tipo_vino) ? v.tipo_vino : 'altro') === tp));
    const regioni = [...new Set(vini.map(v => [v.nazione, v.regione].filter(Boolean).join(' · ')).filter(Boolean))].sort();
    return { tipi, regioni };
  }, [dati]);

  const filtriAttivi = !!(filtri.q.trim() || filtri.tipo || filtri.regione || filtri.grad);

  const gruppi = useMemo(() => {
    if (!dati?.vini) return [];
    const gradDi = v => { const m = String(v.gradazione || '').match(/(\d{1,2}(?:[.,]\d)?)/); return m ? parseFloat(m[1].replace(',', '.')) : null; };
    const q = filtri.q.trim().toLowerCase();
    const viniFiltrati = dati.vini.filter(v => {
      if (filtri.tipo && (ORDINE_TIPI.includes(v.tipo_vino) ? v.tipo_vino : 'altro') !== filtri.tipo) return false;
      if (filtri.regione && [v.nazione, v.regione].filter(Boolean).join(' · ') !== filtri.regione) return false;
      if (filtri.grad) {
        const g = gradDi(v);
        if (g === null) return false;
        if (filtri.grad === 'leggero' && g > 12) return false;
        if (filtri.grad === 'medio' && (g <= 12 || g > 13.5)) return false;
        if (filtri.grad === 'corposo' && g <= 13.5) return false;
      }
      if (q && !`${v.nome} ${v.cantina || ''} ${v.vitigno || ''} ${v.annata || ''}`.toLowerCase().includes(q)) return false;
      return true;
    });
    const perTipo = {};
    viniFiltrati.forEach(v => {
      const tipo = ORDINE_TIPI.includes(v.tipo_vino) ? v.tipo_vino : 'altro';
      if (!perTipo[tipo]) perTipo[tipo] = {};
      const reg = [v.nazione, v.regione].filter(Boolean).join(' · ') || '—';
      if (!perTipo[tipo][reg]) perTipo[tipo][reg] = [];
      perTipo[tipo][reg].push(v);
    });
    return ORDINE_TIPI.filter(tp => perTipo[tp]).map(tp => ({
      tipo: tp,
      regioni: Object.entries(perTipo[tp]).sort(([a], [b]) => a.localeCompare(b))
        .map(([reg, vini]) => ({ regione: reg, vini: vini.sort((a, b) => a.nome.localeCompare(b.nome)) }))
    }));
  }, [dati, filtri]);

  const cambiaLingua = (l) => { localStorage.setItem('carta_vini_lang', l); setLang(l); };

  if (loading && !dati) {
    return (
      <div style={{ minHeight: '100vh', background: tema.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: FONT_CORPO }}>
        <style>{`
          @keyframes somm-sway { 0%, 100% { transform: rotate(-2.5deg) translateY(0); } 50% { transform: rotate(2.5deg) translateY(-8px); } }
          @keyframes somm-dot { 0%, 80%, 100% { opacity: 0.2; } 40% { opacity: 1; } }
        `}</style>
        <div style={{ textAlign: 'center', color: tema.secondario }}>
          <img src="/sommelier-loader.png" alt="" data-testid="carta-loader-sommelier"
            style={{ height: 180, display: 'block', margin: '0 auto', animation: 'somm-sway 2.6s ease-in-out infinite', transformOrigin: 'bottom center', filter: settings.tema === 'scuro' || settings.tema === 'bordeaux' ? 'drop-shadow(0 0 14px rgba(255,255,255,0.12))' : 'none' }} />
          <p data-testid="carta-loading" style={{ marginTop: 18, fontStyle: 'italic', letterSpacing: 1 }}>
            {t.caricamento.replace(/\.+$/, '')}
            {[0, 1, 2].map(i => (
              <span key={i} style={{ animation: `somm-dot 1.4s ${i * 0.25}s infinite` }}>.</span>
            ))}
          </p>
        </div>
      </div>
    );
  }

  if (errore && !dati) {
    return (
      <div style={{ minHeight: '100vh', background: tema.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: FONT_CORPO }}>
        <div style={{ textAlign: 'center', color: tema.secondario, padding: 24 }}>
          <img src="/sommelier-loader.png" alt="" style={{ height: 150, opacity: 0.75, display: 'block', margin: '0 auto' }} />
          <p data-testid="carta-errore" style={{ marginTop: 16, fontStyle: 'italic' }}>{t.erroreCarta}</p>
          <button onClick={() => setReloadKey(k => k + 1)} data-testid="carta-riprova-btn"
            style={{
              marginTop: 14, padding: '10px 28px', borderRadius: 999, cursor: 'pointer', fontSize: 14,
              letterSpacing: 1, border: `1px solid ${tema.accento}`, background: tema.accento, color: '#fff', fontFamily: 'inherit'
            }}>
            {t.riprova}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="carta-vini-pubblica" style={{ minHeight: '100vh', background: tema.bg, color: tema.testo, fontFamily: FONT_CORPO, fontWeight: 400 }}>
      {/* Banner traduzione in corso */}
      {dati?.traduzioni_in_corso && (
        <div data-testid="carta-trad-banner" style={{
          position: 'sticky', top: 0, zIndex: 30, textAlign: 'center', padding: '9px 16px',
          background: tema.accento, color: '#fff', fontSize: 12.5, letterSpacing: 1
        }}>
          {t.traduzione}{dati.traduzioni_totali > 0 ? ` · ${Math.min(99, Math.round((dati.traduzioni_pronte / dati.traduzioni_totali) * 100))}%` : '...'}
        </div>
      )}

      {/* Header */}
      <header style={{ textAlign: 'center', padding: '48px 20px 24px' }}>
        {settings.logo_url && (
          <img src={settings.logo_url} alt={settings.nome_ristorante || 'Logo'} data-testid="carta-logo"
            style={{ maxHeight: 96, maxWidth: 230, objectFit: 'contain', margin: '0 auto 16px', display: 'block' }} />
        )}
        {settings.nome_ristorante && (
          <h1 data-testid="carta-nome-ristorante" style={{ fontFamily: FONT_TITOLO, fontSize: 'clamp(28px, 7vw, 38px)', letterSpacing: 3, lineHeight: 1.2, textTransform: 'uppercase', margin: 0, fontWeight: 700 }}>{settings.nome_ristorante}</h1>
        )}
        <div style={{ width: 60, height: 1, background: tema.accento, margin: '18px auto' }} />
        <h2 style={{ fontFamily: FONT_TITOLO, fontSize: 24, fontStyle: 'italic', fontWeight: 600, color: tema.accento, margin: 0 }}>{settings.sottotitolo || t.carta}</h2>
        {/* Selettore lingua */}
        <div data-testid="carta-lingue" style={{ display: 'flex', justifyContent: 'center', gap: 6, marginTop: 22, flexWrap: 'wrap' }}>
          {Object.entries(dati?.lingue_disponibili || {}).map(([code, nome]) => (
            <button key={code} onClick={() => cambiaLingua(code)} data-testid={`lingua-${code}`}
              style={{
                padding: '7px 15px', borderRadius: 999, fontSize: 13.5, cursor: 'pointer', letterSpacing: 1, fontFamily: 'inherit', fontWeight: 500,
                border: `1px solid ${lang === code ? tema.accento : tema.bordo}`,
                background: lang === code ? tema.accento : 'transparent',
                color: lang === code ? (settings.tema === 'avorio' ? '#fff' : tema.bg) : tema.secondario
              }}>
              {nome}
            </button>
          ))}
        </div>
        {(loading || dati?.traduzioni_in_corso) && <p style={{ color: tema.secondario, fontSize: 12, marginTop: 10 }}>{t.caricamento}</p>}
      </header>

      {/* Filtri rapidi */}
      <div data-testid="carta-filtri" style={{ maxWidth: 780, margin: '0 auto', padding: '4px 20px 0', display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
        <input data-testid="filtro-cerca" value={filtri.q} onChange={e => setFiltri(f => ({ ...f, q: e.target.value }))}
          placeholder={t.cercaVino}
          style={{
            flex: '1 1 200px', maxWidth: 280, padding: '10px 16px', borderRadius: 999, fontSize: 15,
            border: `1px solid ${tema.bordo}`, background: tema.card, color: tema.testo, fontFamily: 'inherit', outline: 'none'
          }} />
        <select data-testid="filtro-tipo" value={filtri.tipo} onChange={e => setFiltri(f => ({ ...f, tipo: e.target.value }))}
          style={{ padding: '10px 12px', borderRadius: 999, fontSize: 15, border: `1px solid ${filtri.tipo ? tema.accento : tema.bordo}`, background: tema.card, color: filtri.tipo ? tema.accento : tema.testo, fontFamily: 'inherit', outline: 'none', cursor: 'pointer' }}>
          <option value="">{t.tuttiTipi}</option>
          {opzioniFiltri.tipi.map(tp => <option key={tp} value={tp}>{tipiLabel[tp]}</option>)}
        </select>
        <select data-testid="filtro-regione" value={filtri.regione} onChange={e => setFiltri(f => ({ ...f, regione: e.target.value }))}
          style={{ padding: '10px 12px', borderRadius: 999, fontSize: 15, maxWidth: 200, border: `1px solid ${filtri.regione ? tema.accento : tema.bordo}`, background: tema.card, color: filtri.regione ? tema.accento : tema.testo, fontFamily: 'inherit', outline: 'none', cursor: 'pointer' }}>
          <option value="">{t.tutteRegioni}</option>
          {opzioniFiltri.regioni.map(r => <option key={r} value={r}>{r}</option>)}
        </select>
        <select data-testid="filtro-gradazione" value={filtri.grad} onChange={e => setFiltri(f => ({ ...f, grad: e.target.value }))}
          style={{ padding: '10px 12px', borderRadius: 999, fontSize: 15, border: `1px solid ${filtri.grad ? tema.accento : tema.bordo}`, background: tema.card, color: filtri.grad ? tema.accento : tema.testo, fontFamily: 'inherit', outline: 'none', cursor: 'pointer' }}>
          <option value="">{t.gradTutte}</option>
          <option value="leggero">≤ 12%</option>
          <option value="medio">12 – 13.5%</option>
          <option value="corposo">&gt; 13.5%</option>
        </select>
        {filtriAttivi && (
          <button data-testid="filtro-azzera" onClick={() => setFiltri({ q: '', tipo: '', regione: '', grad: '' })}
            style={{ padding: '8px 14px', borderRadius: 999, fontSize: 12.5, letterSpacing: 0.5, border: 'none', background: tema.accento, color: '#fff', cursor: 'pointer', fontFamily: 'inherit' }}>
            ✕ {t.azzera}
          </button>
        )}
      </div>

      {/* Lista */}
      <main style={{ maxWidth: 780, margin: '0 auto', padding: '0 20px 80px' }}>
        {gruppi.length === 0 && (
          <div style={{ textAlign: 'center', color: tema.secondario, paddingTop: 30 }}>
            <p data-testid="carta-nessun-risultato">{filtriAttivi ? t.nessunRisultato : t.vuoto}</p>
            {filtriAttivi && (
              <button onClick={() => setFiltri({ q: '', tipo: '', regione: '', grad: '' })}
                style={{ marginTop: 10, padding: '8px 20px', borderRadius: 999, fontSize: 13, border: `1px solid ${tema.accento}`, background: 'transparent', color: tema.accento, cursor: 'pointer', fontFamily: 'inherit' }}>
                {t.azzera}
              </button>
            )}
          </div>
        )}
        {gruppi.map(g => (
          <section key={g.tipo} style={{ marginTop: 42 }}>
            <h3 style={{ fontFamily: FONT_TITOLO, textAlign: 'center', fontSize: fs(27), fontWeight: 700, letterSpacing: 4, textTransform: 'uppercase', color: tema.accento, marginBottom: 4 }}>
              {tipiLabel[g.tipo]}
            </h3>
            <div style={{ width: 34, height: 1, background: tema.bordo, margin: '10px auto 6px' }} />
            {g.regioni.map(r => (
              <div key={r.regione}>
                <h4 style={{ fontSize: fs(13.5), letterSpacing: 2.5, textTransform: 'uppercase', color: tema.secondario, margin: '30px 0 4px', fontWeight: 600 }}>{r.regione}</h4>
                {r.vini.map(v => (
                  <article key={v.id} data-testid="carta-vino-card" style={{ display: 'flex', gap: 16, padding: '18px 0', borderBottom: `1px solid ${tema.bordo}` }}>
                    {settings.mostra_immagini && (
                      <div style={{ width: 72, minWidth: 72, height: 144, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {v.immagine_url ? (
                          <img src={v.immagine_url} alt={v.nome} loading="lazy" onClick={() => setImgAperta(v.immagine_url)} data-testid="carta-vino-img"
                            style={{ maxWidth: 72, maxHeight: 144, objectFit: 'contain', cursor: 'zoom-in', filter: 'drop-shadow(0 4px 10px rgba(0,0,0,0.18))' }} />
                        ) : (
                          <BottigliaVuota colore={tema.accento} />
                        )}
                      </div>
                    )}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
                        <span style={{ fontFamily: FONT_TITOLO, fontWeight: 700, fontSize: fs(21), letterSpacing: 0.3, lineHeight: 1.25 }} data-testid="carta-vino-nome">
                          {v.nome}{v.annata ? ` ${v.annata}` : ''}
                        </span>
                        <span style={{ flex: 1, borderBottom: `1px dotted ${tema.bordo}`, minWidth: 12, transform: 'translateY(-4px)' }} />
                        {settings.mostra_prezzi && v.prezzo_vendita > 0 && (
                          <span style={{ fontFamily: FONT_TITOLO, fontWeight: 700, fontSize: fs(20), color: tema.accento, whiteSpace: 'nowrap' }}>€ {Math.round(v.prezzo_vendita)}</span>
                        )}
                      </div>
                      {v.cantina && (
                        <p style={{ fontFamily: FONT_TITOLO, margin: '3px 0 0', fontStyle: 'italic', fontSize: fs(17.5), fontWeight: 600, color: tema.accento }}>{v.cantina}</p>
                      )}
                      {(v.vitigno || v.gradazione) && (
                        <p style={{ margin: '5px 0 0', fontSize: fs(13), letterSpacing: 1.1, lineHeight: 1.45, fontWeight: 500, color: tema.secondario, textTransform: 'uppercase' }}>
                          {[v.vitigno, v.gradazione].filter(Boolean).join(' · ')}
                        </p>
                      )}
                      {settings.mostra_descrizioni && v.descrizione && (
                        <p style={{ margin: '8px 0 0', fontSize: fs(15.5), fontWeight: 400, lineHeight: 1.6, color: tema.testo }}>{v.descrizione}</p>
                      )}
                      {settings.mostra_descrizioni && v.abbinamenti && (
                        <p style={{ margin: '6px 0 0', fontSize: fs(14.5), lineHeight: 1.5, fontStyle: 'italic', fontWeight: 400, color: tema.secondario }}>{t.abbinamenti}: {v.abbinamenti}</p>
                      )}
                      {settings.mostra_riconoscimenti && v.riconoscimenti && (
                        <p style={{ margin: '6px 0 0', fontSize: fs(14), fontWeight: 600, letterSpacing: 0.3, color: tema.accento }}>★ {v.riconoscimenti}</p>
                      )}
                    </div>
                  </article>
                ))}
              </div>
            ))}
          </section>
        ))}
      </main>

      {/* Zoom immagine */}
      {imgAperta && (
        <div onClick={() => setImgAperta(null)} data-testid="carta-img-zoom"
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, cursor: 'zoom-out' }}>
          <img src={imgAperta} alt="" style={{ maxWidth: '90vw', maxHeight: '85vh', objectFit: 'contain' }} />
        </div>
      )}

      <footer style={{ textAlign: 'center', padding: '0 0 120px', fontSize: 12, letterSpacing: 1.5, color: tema.secondario }}>
        {settings.nome_ristorante ? settings.nome_ristorante.toUpperCase() : ''}
      </footer>

      <ControlloTesto scala={scala} setScala={setScala} tema={tema} />

      {/* Sommelier AI */}
      {dati && (
        <SommelierWidget tenantId={tenantId} lang={lang} tema={tema} t={t} mostraPrezzi={settings.mostra_prezzi !== false} />
      )}
    </div>
  );
}
